import React from 'react'
import { Route, withRouter } from 'react-router-dom'
import { observer } from 'mobx-react'
import { App } from 'antd'
import { Container } from 'typescript-ioc'
import { AqeThemeProvider, ThemeModeProvider, TokenBridge, defaultTokens } from '@pushly/aqe'
import type { AqeTokenConfig } from '@pushly/aqe'
import { SessionState } from '@pushly/aqe'
import { AppState } from '@halo/stores/app.state'
import { AppService } from '@halo/services/app.service'
import { PreAuth } from '@halo/portals/pre-auth'
import { PostAuth } from '@halo/portals/post-auth'
import { classnames } from '@halo/_utils/classnames'
import { LoadingScreen } from '@halo/components/loading-screen/loading-screen'
import { SessionExpiryAdapter } from '@halo/components/session-expiry-adapter/session-expiry-adapter'
import { SessionExpirationScreen } from '@halo/components/session-expiration-screen/session-expiration-screen'
import { halocineTokens } from '@halo/theme/halocline-tokens.config'
import '@halo/style'
import { getPathClassName } from '@halo/_utils/get-path-classname'

// Merge AQE defaults with halocline brand overrides; mirrors pufferfish's
// theme provider stack so the two apps render identically on the same brand tokens.
const haloTheme: AqeTokenConfig = {
    token: { ...defaultTokens.token, ...halocineTokens.token },
    components: { ...defaultTokens.components, ...halocineTokens.components },
}

@observer
class Halo extends React.Component {
    protected appState: AppState
    protected sessionState: SessionState
    protected appService: AppService

    public constructor(props: any) {
        super(props)

        this.appState = Container.get(AppState)
        this.sessionState = Container.get(SessionState)
        this.appService = Container.get(AppService)

        this.appService.attachHistoryContainer((this.props as any).history)
    }

    public render() {
        const pathClassName = getPathClassName(location.pathname)

        return (
            <ThemeModeProvider initialMode="light">
                <AqeThemeProvider theme={haloTheme}>
                    <TokenBridge>
                        <App>
                            <div
                                ref={(el) => (this.appService.appContainerRef = el)}
                                className={classnames('wrapper', pathClassName, {
                                    ['authenticated']: this.sessionState.isAuthenticated,
                                    ['sidebar-open']: !this.appState.sidebar.collapsed,
                                })}
                            >
                                <LoadingScreen />
                                <Route component={PreAuth} {...this.props} />
                                {this.appState.initialized && !this.appState.appIsLoading && (
                                    <>
                                        <SessionExpiryAdapter />
                                        <SessionExpirationScreen />
                                        <Route component={PostAuth} {...this.props} />
                                    </>
                                )}
                            </div>
                        </App>
                    </TokenBridge>
                </AqeThemeProvider>
            </ThemeModeProvider>
        )
    }
}

export default withRouter(Halo)
